import { render, staticRenderFns } from "./WorkflowFolderCard.vue?vue&type=template&id=27bb0193&scoped=true"
import script from "./WorkflowFolderCard.vue?vue&type=script&lang=js"
export * from "./WorkflowFolderCard.vue?vue&type=script&lang=js"
import style0 from "./WorkflowFolderCard.vue?vue&type=style&index=0&id=27bb0193&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27bb0193",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VProgressLinear})
